import { render, staticRenderFns } from "./ProjectSummitLab.vue?vue&type=template&id=472d05da&scoped=true"
import script from "./ProjectSummitLab.vue?vue&type=script&lang=js"
export * from "./ProjectSummitLab.vue?vue&type=script&lang=js"
import style0 from "./ProjectSummitLab.vue?vue&type=style&index=0&id=472d05da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d05da",
  null
  
)

export default component.exports